import React from 'react';
import { CategoryItem } from '../components/CategoryItem';
import { FaqDrawerConstants } from '@src/apps/constants/faq-drawer';

interface AllCategoriesViewProps {
  faqCategories: { CategorySourceId: string; CategorySource: string }[];
  onCategoryClick: (category: { CategorySourceId: string; CategorySource: string }) => void;
  onMostCommonQuestionsClick: () => void;
  onContactUs?: () => void;
}

export const AllCategoriesView: React.FC<AllCategoriesViewProps> = ({
  faqCategories,
  onCategoryClick
}) => {
  return (
    <>
      <div className="main-title">{FaqDrawerConstants.allCategories}</div>

      <div className="categories-section">
        {faqCategories.map((category, index) => (
          <CategoryItem
            key={index}
            category={category.CategorySource}
            onClick={() => onCategoryClick(category)}
          />
        ))}
      </div>
    </>
  );
};
